import React, { useState, useEffect } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import TriangleOverlay from './triangleOverlay';
import AttractorTimeout from '../../warning/attractorTimeout';

const LeaderBoardTriangle = ({ config, location, passRefUpward }) => {
    const [restartGame, setRestartGame] = useState(false);
    const [showSessionScore, setShowSessionScore] = useState(false);
    const [showMoreText, setShowMoreText] = useState(false);
    // Getting answer totals from state - default to 0
    const answerTotals = location.state ? location.state.answerTotals  : {
        words: {
            score: 0,
            hints: 0,
            totalCorrect: 0
        },
        shapes: {
            score: 0,
            hints: 0,
            totalCorrect: 0
        },
        numbers: {
            score: 0,
            hints: 0,
            totalCorrect: 0
        }
    };

    useEffect(() => {
        const sessionData = JSON.parse(window.sessionStorage.getItem('sessionData'));
        const playData = JSON.parse(window.sessionStorage.getItem('playData'));
        sessionData.playData.push(playData);
        window.sessionStorage.setItem('sessionData', JSON.stringify(sessionData));
        // eslint-disable-next-line
    }, []);

    const score = {
        wordScore: answerTotals.words.score,
        numberScore: answerTotals.numbers.score,
        shapeScore: answerTotals.shapes.score
    };

    const getAverageScore = (scores) => {
        let averageScore = 0;
        scores.forEach(score => averageScore += score);
        if (scores.length !== 0) {
            return averageScore / scores.length;
        }
        return 0;
    };

    const sessionTotals = window.sessionStorage.getItem('sessionTotals') ? JSON.parse(window.sessionStorage.getItem('sessionTotals')) : {words: [], shapes: [], numbers: []};
    const sessionTotalWords = getAverageScore(sessionTotals.words);
    const sessionTotalShapes = getAverageScore(sessionTotals.shapes);
    const sessionTotalNumbers = getAverageScore(sessionTotals.numbers);
    const sessionScore = {
        wordScore: sessionTotalWords,
        numberScore: sessionTotalNumbers,
        shapeScore: sessionTotalShapes
    };

    const newSessionTotals = {
        words: [...sessionTotals.words, answerTotals.words.score],
        shapes: [...sessionTotals.shapes, answerTotals.shapes.score],
        numbers: [...sessionTotals.numbers, answerTotals.numbers.score]
    };
    window.sessionStorage.setItem('sessionTotals', JSON.stringify(newSessionTotals));

    AttractorTimeout(config, passRefUpward);

    return (
        <div className='leaderboard-puzzlescreen'>

            {restartGame &&
                <Redirect push to="/introduction" />
            }
            <div className="info">

                    {!showMoreText &&
                        <div className="text-block">
                            <img src="./img/icon-skillstrength.svg" alt="" className="icon"/>
                            <h1>{config.screens.leaderboardScreen.block_title}</h1>
                            {config.screens.leaderboardScreen.text_block.map(text => {
                                return (
                                    <text.element>{text.text}</text.element>
                                )
                            })}
                            <button className="show-more" onClick={() => {setShowMoreText(true)}}>More</button>
                        </div>
                    }

                    {showMoreText &&
                        <div className="text-block more">
                            <img src="./img/icon-skillstrength.svg" alt="" className="icon"/>
                            <h1>{config.screens.leaderboardScreen.more_text_title}</h1>
                            {config.screens.leaderboardScreen.more_text_block.map(text => {
                                return text.element === 'ul' ? (
                                    <text.element>
                                        {text.sub_elements.map(li => (
                                            <li.element>{li.text}</li.element>
                                        ))}
                                    </text.element>
                                ) : (
                                    <text.element>{text.text}</text.element>
                                )
                            })}
                            <button className="show-less" onClick={() => {setShowMoreText(false)}}>Back</button>
                        </div>
                    }

                    {!showMoreText &&
                        <div className='App__button-large-container play-again'>
                            <button onClick={() => setRestartGame(true)}>
                                {config.screens.leaderboardScreen.play_again_button_text}
                            </button>
                        </div>
                    }
            </div>

            <div className="score">
                <span className="title">{config.screens.leaderboardScreen.title}</span>

                <div className="leaderboard-display">
                    <div className="score-text words">
                        <span className="category">Words</span>
                        <span className="details">
                            {answerTotals.words.totalCorrect} correct
                            <span className="divider">|</span>
                            {answerTotals.words.hints} hints
                        </span>
                    </div>
                    <div className="score-text shapes">
                        <span className="category">Shapes</span>
                        <span className="details">
                            {answerTotals.shapes.totalCorrect} correct
                            <span className="divider">|</span>
                            {answerTotals.shapes.hints} hints
                        </span>
                    </div>
                    <div className="score-text numbers">
                        <span className="category">Numbers</span>
                        <span className="details">
                            {answerTotals.numbers.totalCorrect} correct
                            <span className="divider">|</span>
                            {answerTotals.numbers.hints} hints
                        </span>
                    </div>
                    <TriangleOverlay score={score} personal={true} key='average' />
                    {showSessionScore &&
                        <TriangleOverlay score={sessionScore} personal={false} key='personal' />
                    }
                </div>
y

                {/* <span className="other-results">{config.screens.leaderboardScreen.other_results}</span>
                <button
                    className={`toggle-other-results ${showSessionScore ? 'on' : 'off'}`}
                    onClick={() => setShowSessionScore(!showSessionScore)}
                >
                    <span>ON</span>
                    <span>OFF</span>
                </button> */}
            </div>
        </div>
    );
};

export default withRouter(LeaderBoardTriangle);
